import React from "react";
import Plot from 'react-plotly.js';
import {formatCurrency} from "../../utils/formatters";
import {useTheme} from "@mui/material";

export const WaterfallBarChart = ({title, data}) => {
    const theme = useTheme();
    const dims = theme.dimensions;
    const panelTheme = theme.palette.contentPanel;
    const indicatorTheme = theme.palette.indicator;

    if (!data || Object.keys(data).length === 0) return <div/>;

    const xData = ['Gross<br>Price', 'Unit<br>Discount', 'Net<br>Price', 'Unit<br>VCOGS',
        'Unit<br>Variable<br>Margin', 'Unit<br>Freight<br>Costs', 'Unit<br>Commissions', 'Unit<br>Pocket<br>Price<br>Margin'];

    const buildTrace = (traceData, color) => {
        return {
            x: xData,
            y: traceData,
            type: 'bar',
            marker: {color: color}
        };
    };

    const baseTraceValues = [0, data.gross_price - data.unit_discount_amount, 0, data.net_price - data.unit_vcogs,
        0, data.unit_variable_margin - data.unit_freight_costs, data.unit_variable_margin - data.unit_freight_costs - data.unit_commission_costs, 0];
    const greenTraceValues = [data.gross_price, 0, 0, 0, 0, 0, 0, 0];
    const redTraceValues = [0, data.unit_discount_amount, 0, data.unit_vcogs, 0, data.unit_freight_costs, data.unit_commission_costs, 0];
    const blueTraceValues = [0, 0, data.net_price, 0, data.unit_variable_margin, 0, 0, data.unit_pocket_price_margin];

    const transparentTrace = buildTrace(baseTraceValues, 'rgba(1,1,1,0.0)');
    const greenTrace = buildTrace(greenTraceValues, indicatorTheme.table.green);
    const redTrace = buildTrace(redTraceValues, indicatorTheme.table.red);
    const blueTrace = buildTrace(blueTraceValues, indicatorTheme.table.blue);
    const plotData = [transparentTrace, greenTrace, redTrace, blueTrace];

    const verticalOffset = Math.round(Math.max(...Object.values(data)) * 0.03);
    const yData = [
        greenTraceValues[0] + verticalOffset,
        baseTraceValues[1] - verticalOffset,
        blueTraceValues[2] + verticalOffset,
        baseTraceValues[3] - verticalOffset,
        blueTraceValues[4] + verticalOffset,
        baseTraceValues[5] - verticalOffset,
        baseTraceValues[6] - verticalOffset,
        blueTraceValues[7] + verticalOffset
    ];
    const annotations = [
        {x: xData[0], y: yData[0], showarrow: false, text: formatCurrency(data.gross_price, true), font: {color: yData[0] < 0 ? 'white' : ''}},
        {x: xData[1], y: yData[1], showarrow: false, text: formatCurrency(0 - data.unit_discount_amount, true)},
        {x: xData[2], y: yData[2], showarrow: false, text: formatCurrency(data.net_price, true), font: {color: yData[2] < 0 ? 'white' : ''}},
        {x: xData[3], y: yData[3], showarrow: false, text: formatCurrency(0 - data.unit_vcogs, true)},
        {x: xData[4], y: yData[4], showarrow: false, text: formatCurrency(data.unit_variable_margin, true), font: {color: yData[4] < 0 ? 'white' : ''}},
        {x: xData[5], y: yData[5], showarrow: false, text: formatCurrency(0 - data.unit_freight_costs, true)},
        {x: xData[6], y: yData[6], showarrow: false, text: formatCurrency(0 - data.unit_commission_costs, true)},
        {x: xData[7], y: yData[7], showarrow: false, text: formatCurrency(data.unit_pocket_price_margin, true), font: {color: yData[7] < 0 ? 'white' : ''}}
    ];

    return (
        <div style={{...panelTheme, padding: 5, marginTop: 20, width: dims.contentWidth}}>
            <Plot data={plotData}
                  layout={{
                      width: dims.contentWidth - 10,
                      height: 500,
                      margin: {t: 50, b: 70, l: 50, r: 20},
                      title: {text: title},
                      barmode: 'stack',
                      showlegend: false,
                      annotations: annotations
                  }}
                  config={{displayModeBar: false}}
            />
        </div>
    );
};
